import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll } from "@nosto/preact";

import NoResults from "./NoResults";
import Products from "./Products";
import CategoryToolbar from "./CategoryToolbar";
import CategorySidebar from "./CategorySidebar";
import Sidebar from "./Sidebar";
import BottomToolbar from "./BottomToolbar";
import SelectedFilters from "./SelectedFilters";
import Loader from "./elements/Loader";

export default function Category() {
  const {
    response: { products },
    loading,
  } = useAppState();
  const foundProducts = products && products.total > 0;

  let isMobile = window.innerWidth < 769;

  return (
    <div
      class="ns-serp ns-category ns-d-flex ns-flex-column ns-font-inherit"
      style="margin: auto; "
    >
      {foundProducts && (
        <>
          <CategorySidebar />
          <CategoryToolbar mobile />
        </>
      )}
      <div class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0">
        {foundProducts ? (
          <>
            <CategoryToolbar />
            <Products />
            <BottomToolbar />
          </>
        ) : loading ? (
          <Loader />
        ) : (
          <NoResults />
        )}
      </div>
    </div>
  );
}
